import { Component, OnInit, OnDestroy, Input,AfterViewInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormControl, FormArray, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { Subscription } from 'rxjs/Subscription';
import { Router, ActivatedRoute } from '@angular/router';
import { StudentChecklistService } from '../../_services/index';
import { DOCUMENT} from '@angular/common';
import { PageScrollConfig, PageScrollService, PageScrollInstance } from 'ngx-page-scroll';

@Component({
  selector: 'app-student-default-checklist',
  templateUrl: './student-default-checklist.component.html',
  styleUrls: ['./student-default-checklist.component.css'],
  providers:[StudentChecklistService]
  
})
export class StudentDefaultChecklistComponent implements OnInit {
  checklistForm: FormGroup;
  formChangeSub: Subscription;
  getdataSub: Subscription;
  submitdataSub: Subscription;
  
  error: boolean;
  errorFlag: boolean;
  successMessage: string;
  errorMessage: string;
  submitBtnText = '';
  submitting: boolean;
  fieldErrors:any;
  public personalEmail: string;
  currentUser:any;
  loading: boolean;
  public checkChange: boolean;
  public valueChange = false;
  
  public question1;
  public question2;
  public question3;
  public question4;
  public checkboxesArray1 = [];
  public checkboxesArray2 = [];
  public checkboxesArray3 = [];
  public checkboxesArray4 = [];

  @ViewChild('container')
  private container: ElementRef;

  constructor(private _fb: FormBuilder,
    private router: Router,
    public api: StudentChecklistService,   
    private route: ActivatedRoute,
    private pageScrollService: PageScrollService, 
    @Inject(DOCUMENT) private document: any) {

      
  }

  ngOnInit() {

    this.getQuestions();
    this.createForm();
   

  }


  getQuestions() {
    
    this.loading = true;
    
    this.api.getQuestions()
        .subscribe(responseData => {
          
          Object.keys(responseData.data).forEach(key=> {

            if(key == '1')
            {
              this.question1 = responseData.data[key];
              for (let question of this.question1) {
                this.checkboxesArray1.push(this._fb.group({
                  isChosen: false,
                  name: question.question,
                  id: question.id,
                  
                }));
              }
              
            }
            else if(key == '2')
            {
              var notNullValues = new Array();
              var nullValues = new Array();

              this.question2 = responseData.data[key];

              for(let key in this.question2){
                  var value = this.question2[key];
                  if(value ===null){
                    nullValues.push({
                      key: value
                    });
                  } else {
                    notNullValues.push(
                        value
                    );
                  }
              }

              for (let question2 of notNullValues) {
                this.checkboxesArray2.push(this._fb.group({
                  isChosen: false,
                  name: question2.question,
                  id: question2.id,
                  
                }));
              }
              
            }
            else if(key == '3')
            {
              var notNullValues = new Array();
              var nullValues = new Array();

              this.question3 = responseData.data[key];

              for(let key in this.question3){
                var value = this.question3[key];
                if(value ===null){
                  nullValues.push({
                    key: value
                  });
                } else {
                  notNullValues.push(
                      value
                  );
                }
              }

              for (let question3 of notNullValues) {
                this.checkboxesArray3.push(this._fb.group({
                  isChosen: false,
                  name: question3.question,
                  id: question3.id,
                  
                }));
              }
              
            }
            else if(key == '4')
            {
              var notNullValues = new Array();
              var nullValues = new Array();

              this.question4 = responseData.data[key];

              for(let key in this.question4){
                var value = this.question4[key];
                if(value ===null){
                  nullValues.push({
                    key: value
                  });
                } else {
                  notNullValues.push(
                      value
                  );
                }
            }

              for (let question4 of notNullValues) {
                this.checkboxesArray4.push(this._fb.group({
                  isChosen: false,
                  name: question4.question,
                  id: question4.id,
                  
                }));
              }
              
            }

            let pageScrollInstance: PageScrollInstance = PageScrollInstance.simpleInstance(this.document, '.bodyWrapper');
            this.pageScrollService.start(pageScrollInstance);
            console.log('c');
            
          });

          this.loading = false;
          this.createForm();
          this.getStudentChecklist();
        });
  }

  private _onValueChanged() {
    
    if(this.checkChange)
    {
      this.valueChange = true

    }
        
  }

  createForm()  {

    let formControlArray1 = new FormArray(this.checkboxesArray1);
    let formControlArray2 = new FormArray(this.checkboxesArray2);
    let formControlArray3 = new FormArray(this.checkboxesArray3);
    let formControlArray4 = new FormArray(this.checkboxesArray4);
        
    this.checklistForm  = this._fb.group({
      checklist1: formControlArray1,
      checklist2: formControlArray2,
      checklist3: formControlArray3,
      checklist4: formControlArray4,
      
    });
    console.log(this.checklistForm);

  }

  onSubmit() {

    this.loading = true;
    console.log(this.checklistForm.value);
    const body = JSON.stringify({

      checklist1: JSON.stringify( this.checklistForm.controls.checklist1.value ),
      checklist2: JSON.stringify( this.checklistForm.controls.checklist2.value ),
      checklist3: JSON.stringify( this.checklistForm.controls.checklist3.value ),
      checklist4: JSON.stringify( this.checklistForm.controls.checklist4.value ),
      
    });

    this.submitdataSub = this.api.addStudentChecklist$(body)
    .subscribe(
      data => {
        this.error = false;
        this.submitting = false;
        
          this.errorFlag = false;
          const response = JSON.parse(data._body);
          this.successMessage = response.message;
          this.loading = false;
          //console.log(this.successMessage);
          //console.log(this.errorFlag);
          
          let pageScrollInstance: PageScrollInstance = PageScrollInstance.simpleInstance(this.document, '.student-layout-wrapper');
          this.pageScrollService.start(pageScrollInstance);
      
      },
      error => {
        this.submitting = false;
        this.errorFlag = true;
        const errordata = JSON.parse(error._body);
        if (errordata.success === 0) {
          this.errorMessage = errordata.message;
          this.errorFlag = true;
          this.fieldErrors = errordata.errors;
          this.loading = false;
          let pageScrollInstance: PageScrollInstance = PageScrollInstance.simpleInstance(this.document, '.student-layout-wrapper');
          this.pageScrollService.start(pageScrollInstance);
      
        }
      },
    );
  }

  getStudentChecklist() {
    
    this.loading = true;
    const body = JSON.stringify({
          email: this.personalEmail
    });

    this.getdataSub = this.api.getStudentChecklist(body).subscribe(responsedata => {
        
        //console.log(responsedata.data);
        let checklistdata = responsedata.data;
        let checklist1 = JSON.parse(checklistdata.checklist1);
        let checklist2 = JSON.parse(checklistdata.checklist2);
        let checklist3 = JSON.parse(checklistdata.checklist3);
        let checklist4 = JSON.parse(checklistdata.checklist4);
        
        if(checklist1)
        {
          this.checklistForm.controls['checklist1'].setValue(checklist1);
          
        }

        if(checklist2)
        {
          this.checklistForm.controls['checklist2'].setValue(checklist2);
          
        }

        if(checklist3)
        {
          this.checklistForm.controls['checklist3'].setValue(checklist3);
          
        }

        if(checklist4)
        {
          this.checklistForm.controls['checklist4'].setValue(checklist4);
          
        }
        
    });
    
  }
}



// WEBPACK FOOTER //
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/pages/student-default-checklist/student-default-checklist.component.ts